import { useState } from "react";

export default function MyInfoComponent({ data }) {
  const [fresh, setFresh] = useState(false);
  console.log("rendering myinfo ");
  console.log(data);
  let d = JSON.parse(localStorage.getItem("pdata"));
  console.log(d);

  function btnHandler() {
    console.log("click");
    setFresh((p) => !p);
    console.log(fresh);
  }
  return (
    <>
      {" "}
      <h3>My Information</h3>
      {d ? (
        <>
          {" "}
          <label htmlFor="">Name : </label>
          <input type="text" value={d?.name} readOnly /> <br />
          <label htmlFor="">Phone : </label>
          <input type="text" value={d?.phone} readOnly /> <br />
          <label htmlFor="">Restaurant ID: </label>
          <input type="text" value={d?.restaurantId} readOnly />
        </>
      ) : (
        <button onClick={btnHandler}>View</button>
      )}
    </>
  );
}
